import * as React from 'react';
import { FixMeLater } from '../../utils';

export type OptionListItemProps = {
    /**
     * The content of the component.
     */
    children: React.ReactNode;

    role?: string;
};

export const OptionListItem: React.ForwardRefExoticComponent<OptionListItemProps & React.RefAttributes<HTMLElement>> =
    React.forwardRef(function OptionListItem(
        props: OptionListItemProps,
        ref: React.ForwardedRef<FixMeLater>
    ): React.JSX.Element {
        const { children, role, ...other } = props;

        return (
            <li ref={ref} role={role} {...other}>
                {children}
            </li>
        );
    });
